import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Main() {
  const navigate = useNavigate();

  const handleToursClick = () => {
    navigate('/ManageTours');
  };

  const handleCarRentsClick = () => {
    navigate('/ManageCars');
  };



  useEffect(() => {
    const hasRefreshed = sessionStorage.getItem('hasRefreshed');
    console.log("hasRefreshed:", hasRefreshed);
    if (!hasRefreshed) {
      sessionStorage.setItem('hasRefreshed', 'true');
      window.location.reload(); 
    }
  }, []); 

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column', // Stack buttons vertically for small screens, horizontally for large ones
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh', // Full viewport height
        width: '100vw', // Full viewport width
        background: 'linear-gradient(to right, #6a11cb, #2575fc)', // Gradient background
        fontFamily: 'Arial, sans-serif',
        cursor: 'default',
        overflow: 'hidden', // Prevent overflow on the main container
      }}
    >
      {/* Button Container */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'row', // Horizontal layout for larger screens
          flexWrap: 'wrap', // Allow buttons to stack vertically on smaller screens
          justifyContent: 'center',
          alignItems: 'center',
          width: '90%',
          maxWidth: '1200px', // Limit max width for large screens
          overflow: 'hidden', // Prevent overflow inside button container
        }}
      >
        {/* Left Side Button (Tours) */}
        <div
          onClick={handleToursClick}
          style={{
            width: '48%', // Ensure it takes half of the width of the container
            height: '200px', // Set a fixed height for consistency
            backgroundColor: '#4CAF50',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            borderRadius: '12px',
            boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.2)',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease',
            margin: '10px', // Ensure some space between buttons
            flexBasis: '45%', // Responsive layout
            textAlign: 'center',
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#45a049'} // Darker green on hover
          onMouseLeave={(e) => e.target.style.backgroundColor = '#4CAF50'} // Original green
        >
          <h1 style={{ color: 'white', fontSize: '2.5rem', margin: 0 }}>Tours</h1>
        </div>

        {/* Right Side Button (Car Rents) */}
        <div
          onClick={handleCarRentsClick}
          style={{
            width: '48%', // Ensure it takes half of the width of the container
            height: '200px', // Set a fixed height for consistency
            backgroundColor: '#2196F3',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            borderRadius: '12px',
            boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.2)',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease',
            margin: '10px', // Ensure some space between buttons
            flexBasis: '45%', // Responsive layout
            textAlign: 'center',
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#1976D2'} // Darker blue on hover
          onMouseLeave={(e) => e.target.style.backgroundColor = '#2196F3'} // Original blue
        >
          <h1 style={{ color: 'white', fontSize: '2.5rem', margin: 0 }}>Car Rents</h1>
        </div>
      </div>
    </div>
  );
}

export default Main;
